import IIdentificationDocument from "@/module/main/dto/customer/IIdentificationDocument";

export default class IdentificationDocument implements IIdentificationDocument {
    constructor(
        public number?: string,
        public validity?: string,
    ) {
    }
}
